import { render } from "./ListItems.vue?vue&type=template&id=247f4844&scoped=true"
import script from "./ListItems.vue?vue&type=script&lang=js"
export * from "./ListItems.vue?vue&type=script&lang=js"

import "./ListItems.vue?vue&type=style&index=0&id=247f4844&scoped=true&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247f4844"]])

export default __exports__